export default function StatsCards({
  totalAmount,
  totalEntries,
  totalNotebook,
  showNotebook = true, // default true for Lavajam, can be false for Daan
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-3">
      <div className="bg-gradient-to-r from-green-400 to-green-600 rounded-xl py-3 px-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-green-100 text-sm font-medium">Total Amount</p>
            <p className="text-2xl font-bold">
              ₹{(totalAmount || 0).toLocaleString("en-IN")}
            </p>
          </div>
          <div className="w-8 h-8 bg-green-300 bg-opacity-30 rounded-full flex items-center justify-center text-green-100 text-lg font-bold">
            ₹
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-blue-400 to-blue-600 rounded-xl py-3 px-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-blue-100 text-sm font-medium">Total Entries</p>
            <p className="text-2xl font-bold">
              {(totalEntries || 0).toLocaleString("en-IN")}
            </p>
          </div>
          <div className="w-8 h-8 bg-blue-300 bg-opacity-30 rounded-full flex items-center justify-center">
            <div className="w-4 h-4 bg-blue-100 rounded-full"></div>
          </div>
        </div>
      </div>

      {showNotebook && (
        <div className="bg-gradient-to-r from-purple-400 to-purple-600 rounded-xl py-3 px-6 text-white shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100 text-sm font-medium">
                Total Notebook
              </p>
              <p className="text-2xl font-bold">
                {totalNotebook
                  ? Math.round(totalNotebook).toLocaleString("en-IN")
                  : "0"}
              </p>
            </div>
            <div className="w-8 h-8 bg-purple-300 bg-opacity-30 rounded-full flex items-center justify-center">
              <div className="w-4 h-2 bg-purple-100 rounded-sm"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
